module.exports = "<span ng-bind=::$ctrl.distance></span>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/hotels/distance-unit/distance-unit.html
// module id = 3226
// module chunks = 0